// File: cgp-alert-dialog.module.ts
// Author: Joseph M Diaz
// Date: 4/27/2017
// Desc: CGP Alert Dialog to use instead of js alert.
// Other Contributors:

import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

import { CgpAlertDialogService } from './cgp-alert-dialog.service';
import { CgpAlertDialogComponent } from './cgp-alert-dialog.component';

@NgModule({
    imports: [
        MatDialogModule,
        MatButtonModule
    ],
    exports: [
        CgpAlertDialogComponent
    ],
    declarations: [
        CgpAlertDialogComponent
    ],
    providers: [
        CgpAlertDialogService
    ]
})
export class CgpAlertDialogModule { }